import { useSyncExternalStore } from 'react';
import { configureClient } from '@/api';

let online = typeof navigator === 'undefined' ? true : navigator.onLine;
const subs = new Set<() => void>();
const set = (v: boolean) => {
  if (v !== online) {
    online = v;
    subs.forEach((s) => s());
  }
};

/** Connectivity as observed by the API client (a failed fetch = offline) and the browser. */
export function installConnectivity() {
  configureClient({ onNetworkState: set });
  window.addEventListener('online', () => set(true));
  window.addEventListener('offline', () => set(false));
}

export function useConnectivity(): boolean {
  return useSyncExternalStore(
    (cb) => {
      subs.add(cb);
      return () => subs.delete(cb);
    },
    () => online,
    () => true,
  );
}
